
import { PropertyAttachmentDTO } from './propertyAttachmentDTO';
import { AuctionDTO } from './auctionDTO';
import { AddressDTO } from './addressDTO';
import { PropertyImagePoolDTO } from './propertyImagePoolDTO';

export class PropertyDTO{
    public id! : number;
    public propertyId! : string;
    public businessId! : string;
    public inventoryId? : number;
    public clientId? : number;
    public taxYear? : number;
    public header? : string;
    public description? : string;
    public typeId? : number;
    public subTypeId? : number;
    public address? : AddressDTO;
    public saleTypeId? : number;
    public auctionRuleId? : number;
    public yearBuilt? : number;
    public annualTaxes? : string;
    public lotSize? : number;
    public parcelId? : string;
    public appraisalAmount? : number;
    public bedrooms? : number;
    public bathroomsFull? : number;
    public bathroomsHalf? : number;
    public garages? : number;
    public carPorts? : number;
    public area? : number;
    public stories? : string;
    public units? : number;
    public unitMix? : string;
    public showingsAvailable : boolean = false;
    public latitude? : number;
    public longitude? : number;
    public judgeId? : number;
    public plaintiff? : string;
    public defendant? : string;
    public fileNo? : string;
    public caseNo? : string;
    public clientFileNo? : string;
    public attorneyFileNo? : string;
    public sold : boolean = false;
    public showSold : boolean = false;
    public additionalAddresses : AddressDTO[];
    public revision? : number;
    public portfolioId? : number;
    public commission? : number;
    public commissionValue? : number;
    public salesManagerId? : string;
    public propertyManagerId? : string;
    public assetManagerIds? : string; //comma seperated list of client userIds
    public attorneyIds? : string; //comma seperated list of attorney userIds
    public titleCompany? : string;
    public buyerId? : string;
    public propertyPhaseId? : number = 10;

    public attachments : PropertyAttachmentDTO[];
    public auction? : AuctionDTO;

    public added? : string;
    public edited? : string;
    public updated? : string;
    public visibilitySince?: string;
    public addedByUserId? : string;
    public editedByUserId? : string;
    
    public removedImages? : number[];
    //image pool: read for the property master (attachments = public images only), on save the pool in pool order
    public imagePool? : PropertyImagePoolDTO[];

    public removedDocuments? : number[];

    public officialUpdate : boolean=false;

    public views? : number;

    constructor(){
        this.attachments=[];
        this.additionalAddresses= [];
        this.addedByUserId='';
        this.editedByUserId='';
    }
}